import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../../contexts/AuthProvider';
import { USER_ROLES } from '../../constants';

interface RequirePlanProps {
  children: React.ReactNode;
}

export function RequirePlan({ children }: RequirePlanProps) {
  const { user, isLoading: authLoading } = useAuth();

  // Still loading
  if (authLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-neutral-50 dark:bg-neutral-900">
        <div className="w-8 h-8 border-4 border-brand-500 dark:border-brand-400 border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  // Not authenticated
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Admin bypass - always allow
  if (user.role === USER_ROLES.ADMIN) {
    return <>{children}</>;
  }

  // Check if user needs to select a plan
  const hasPlan = user.subscription_status && ['free', 'active', 'grandfathered'].includes(user.subscription_status);

  if (!hasPlan) {
    return <Navigate to="/select-plan" replace />;
  }

  // User has a valid plan, show protected content
  return <>{children}</>;
}
